/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactMessageControllerService {
    /**
     * @param requestBody Contact form data
     * @returns any Contact message sent successfully
     * @throws ApiError
     */
    public static contactMessageControllerSendMessage(
        requestBody: {
            name: string;
            email: string;
            phone?: string;
            message: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contact-message',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
